import React, { useContext, Fragment } from 'react';
import content from 'Content/content.json';
import { language, enableBuyProductButton } from 'Root/constants';
import VMContext from '../context';
import { Image } from 'Components/commonComponents';
import { imageSet } from 'Components/helper/Images';
import './BuyProductButton.scss';

const BuyProductButton = () => {
  const buy_icon = 'external_buy_standard';
  const {
    selectedLensType,
    lensIndex,
  } = useContext(VMContext);
  const lens = content.data.productInfo[language][selectedLensType][lensIndex];

  return (
    <Fragment>
      {enableBuyProductButton && lens.external_product && (
        <div className="buy-product-button buy-product-button-wrapper">
          <div className="buy-product-button-inner">
            {lens.external_product.P10 && (
              <a className="buy-product-button-item buy-product-button-item-p10" href={lens.external_product.P10} target='_blank'>
              {imageSet[buy_icon] && (
                <Fragment>
                  <span>10P</span>
                  <Image className='buy-product-button-item--icons-cart' src={imageSet[buy_icon]} />
                </Fragment>
              )}
              </a>
            )}
            {lens.external_product.P30 && (
              <a className="buy-product-button-item buy-product-button-item-p30" href={lens.external_product.P30} target='_blank'>
              {imageSet[buy_icon] && (
                <Fragment>
                  <span>30P</span>
                  <Image className='buy-product-button-item--icons-cart' src={imageSet[buy_icon]} />
                </Fragment>
              )}
              </a>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default BuyProductButton;